import { useEffect, useState, useReducer } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/esm/Button";
import { Container, Row, Col, Form } from "react-bootstrap";
import ShareItem from "./ShareItem";
import OrgUserToggle from "./OrgUserToggle";
import NewOrgUser from "./NewOrgUser";
import ShareRows from "./ShareRows";
import Definitions from "../definitions";
import ModalAlert from "./ModalAlert";

function ShareModal({
  show,
  toggleShare,
  close,
  item,
  items,
  users,
  setUsers,
  updateItems,
}) {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [shares, setShares] = useState([]);
  const [displayOrgInvite, setDisplayOrgInvite] = useState(false);

  // Modal alert settings
  const [modalAlert, setModalAlert] = useState({
    show: false,
    message: "",
    isError: false,
  });

  useEffect(() => {}, [shares, item]);

  useEffect(() => {
    let tempAry = [];
    if (item.active && item.expired) {
      let tempShare = item.active;
      tempAry = tempShare.concat(item.expired);
    } else {
      tempAry = item.active;
    }

    for (var key in tempAry) {
      // Unset key in ary if share_user_id is not set or not a number
      if (!("share_user_id" in tempAry[key])) {
        delete tempAry[key];
      }
    }

    if (typeof tempAry == "object") {
      // convert tempAry to array
      tempAry = Object.values(tempAry);
    }

    setShares(tempAry);
  }, [item]);

  function onHide(){
    setDisplayOrgInvite(false);
    setModalAlert( (old) => ({...old, show:false, isError:false, message:""}) );
    close();
  }

  return (
    <Modal
      show={show}
      onHide={() => onHide()}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Share:{ item?.content_type in Definitions && "alt" in Definitions[item?.content_type] ? " " + Definitions[item?.content_type].alt + ":" : ""} {item.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        
        <ModalAlert settings={modalAlert} setSettings={setModalAlert} />

        <Container className="share-controls">
          <ShareItem
            setAlert={setModalAlert}
            items={items}
            item={item}
            users={users}
            toggleShare={toggleShare}
            updateItems={updateItems}
            setShares={setShares}
            shares={shares}
            forceUpdate={forceUpdate}
          />
          <OrgUserToggle
            display={displayOrgInvite}
            toggle={setDisplayOrgInvite}
          />
          
          <NewOrgUser
            display={displayOrgInvite}
            setUsers={setUsers}
            setAlert={setModalAlert}
          />
        </Container>

        <ShareRows
          setAlert={setModalAlert}
          shares={shares}
          setShares={setShares}
          item={item}
          setItems={updateItems}
        />
      </Modal.Body>
    </Modal>
  );
}

export default ShareModal;
